import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Checkbox, Drawer, Input, message, Popconfirm, Table } from 'antd';
import { TestBank } from 'model/response';
import React, { useEffect, useState } from 'react';

import { deleteTestBank, editTestBank, findAllTestBank } from '../../../../service/testBankService';

import { ColumnsType } from 'antd/es/table';
import useTableConfig from '../../../../hooks/useTableConfig';
import processError from '../../../../utils/processError';

export default function TestBankTable() {
  const { pageSize, currentPage, sortBy, direction, pagination, setTotalElements, getColumnSorter, handleTableChange } =
    useTableConfig();
  const [data, setData] = useState<TestBank[]>([]);
  const [loading, setLoading] = useState(false);
  const [childrenAppendixDrawerVisible, setChildrenAppendixDrawerVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<TestBank | null>(null);
  const [newTestBank, setNewTestBank] = useState('');

  useEffect(() => {
    handleFindAll().then();
  }, []);

  useEffect(() => {
    if (selectedRecord) {
      setNewTestBank(selectedRecord.name || '');
    }
  }, [selectedRecord]);

  const columns: ColumnsType<TestBank> = [
    {
      title: 'Tên ngân hàng',
      dataIndex: 'name',
      align: 'left',
      width: '40%',
      sorter: true,
      sortOrder: getColumnSorter('name'),
    },
    {
      title: 'Mã ngân hàng',
      dataIndex: 'code',
      align: 'left',
      sorter: true,
      sortOrder: getColumnSorter('code'),
    },
    {
      title: 'Hiển thị',
      dataIndex: 'webViewActive',
      align: 'center',
      render: (_, record) => <Checkbox checked={record.webViewActive} />,
      sorter: true,
      sortOrder: getColumnSorter('webViewActive'),
    },
    {
      title: 'Thứ tự',
      dataIndex: 'webViewOrder',
      align: 'center',
      sorter: true,
      sortOrder: getColumnSorter('webViewOrder'),
    },
    {
      title: 'Hành động',
      dataIndex: 'action',
      align: 'center',
      render: (_, record) => (
        <div className="flex item-center w-full justify-center gap-2">
          <button
            className="p-2 rounded bg-[#0066FF] text-white"
            onClick={() => {
              setSelectedRecord(record);
              setChildrenAppendixDrawerVisible(true);
            }}
          >
            <EditOutlined />
          </button>
          <Popconfirm
            title="Xóa ngân hàng"
            description="Xác nhận xóa ngân hàng. Hành động này không thể hoàn tác?"
            onConfirm={() => {
              setSelectedRecord(record);
              handleDeleteTestBank(record).then();
            }}
            okText="Đồng ý"
            cancelText="Hủy"
          >
            <button className="p-2 rounded bg-[#FF0000] text-white">
              <DeleteOutlined />
            </button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleEditTestBank = async () => {
    try {
      await editTestBank(selectedRecord?.id, newTestBank);
      await handleFindAll();
      message.success('Sửa ngân hàng thành công');
    } catch (err) {
      processError(err);
    }
  };
  const handleDeleteTestBank = async (record: any) => {
    try {
      await deleteTestBank(record.id);
      await handleFindAll();
      message.success('Xóa ngân hàng thành công');
    } catch (err) {
      processError(err);
    }
  };

  const handleFindAll = async () => {
    findAllTestBank()
      .then((s) => {
        setData(s);
      })
      .catch();
  };

  return (
    <div className="bg-white rounded">
      <div>
        <div className="flex flex-col ">
          <Table
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.id}
            loading={loading}
            pagination={pagination}
            onChange={handleTableChange}
            bordered
          />
          <Drawer
            title="Sửa ngân hàng"
            placement="right"
            width={400}
            closable={false}
            onClose={() => setChildrenAppendixDrawerVisible(false)}
            open={childrenAppendixDrawerVisible}
            footer={
              <div style={{ textAlign: 'left' }}>
                <Button onClick={() => setChildrenAppendixDrawerVisible(false)} style={{ marginRight: 8 }}>
                  Hủy
                </Button>
                <Button type="primary" onClick={handleEditTestBank}>
                  Lưu
                </Button>
              </div>
            }
          >
            <Input
              placeholder="Nhập tên..."
              value={newTestBank}
              onChange={(e) => setNewTestBank(e.target.value)}
              required
            />
            <br />
          </Drawer>
        </div>
      </div>
    </div>
  );
}
